import Cover from "../../components/cover/cover";
import { useLocation } from "react-router-dom";
import Slots from "../../components/slots/slots";
import { getContainerClass } from "../../components/navigation/navigation";
// import Header from "../../components/header/header";
const AddFacilityPage = () => {
  const breadcrumb = ["Home","Facilities","Slots"];
  const location = useLocation();
  return (
    <>
      <div className={getContainerClass(location.pathname)}>
        {/* <Header /> */}
        <Cover breadcrumb={breadcrumb} page="slots" />
        <div className="">
          <Slots />
        </div>
      </div>
    </>
  );
};

export default AddFacilityPage;
